import {useEffect, useState} from "react";

export const useStableNow = (initialNow?: number | null): number | null => {
    const [now, setNow] = useState<number | null>(() => {
        if (typeof initialNow === "number" && Number.isFinite(initialNow)) {
            return initialNow;
        }
        if (typeof window === "undefined") {
            return null;
        }
        return Date.now();
    });

    useEffect(() => {
        if (typeof window === "undefined") {
            return;
        }
        setNow(Date.now());
    }, []);

    return now;
};
